import { tracer, uxrr } from '@zyno-io/uxrr-client';

export { tracer };

export const OtelState: {
    userId?: string;
    userName?: string;
    userEmail?: string;
    tenantId?: string;
    browserId?: string;
    workstationId?: string;
} = {};

export function syncIdentity() {
    uxrr.identify({
        deviceId: OtelState.workstationId,
        userId: OtelState.userId,
        userName: OtelState.userName,
        userEmail: OtelState.userEmail
    });
}

export function getSpanAttributes(): Record<string, string> {
    const attrs: Record<string, string> = {};
    if (OtelState.tenantId) attrs['zs.tid'] = OtelState.tenantId;
    if (OtelState.userId) attrs['zs.aid'] = OtelState.userId;
    if (OtelState.browserId) attrs['zs.bid'] = OtelState.browserId;
    if (OtelState.workstationId) attrs['zs.wid'] = OtelState.workstationId;
    return attrs;
}
